<template>
  <div>
    <b>#{{ item.name }}</b>
    <span>{{ item.words.join(', ') }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      item: { required: true }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// suggestion-item-template.vue?7ad58b7c